<div>
  <div class="col pl-0">
    <h4 class="mb-2 font-header-1">Add Ticket</h4>
  </div>
  <div class="row mb-2 mt-4">
    <div class="col ">
      <div widget class="card border-0 box-shadow">
        <div class="card-header transparent  text-muted">
          <div class="row mt-2 ms-2 p-10">
            <div class="col-12">

              <button type="button" class="btn blue-btn btn-sm" style="float: right;"
                (click)="backwithalert()">Close</button>
              <button class="btn blue-btn btn-sm me-2" (click)="savetickets(Tickets)" style="float: right;" *ngIf="fp?.ticketSave"
                [disabled]="!ticketsForm.valid"><span
                  *ngIf="ticketsForm.get('id').value == '00000000-0000-0000-0000-000000000000'"> Save</span> <span
                  *ngIf="ticketsForm.get('id').value != '00000000-0000-0000-0000-000000000000'">Update</span> </button>

              <button class="btn btn-sm me-2"
                *ngIf="ticketsForm.get('id').value != '00000000-0000-0000-0000-000000000000'&& fp?.linkEngagement" data-bs-toggle="modal"
                data-bs-target="#linkEngagement" (click)="getEngagementdd();">Link Engagement</button>
              <button class="btn btn-sm me-2"
                *ngIf="ticketsForm.get('id').value != '00000000-0000-0000-0000-000000000000'&& fp?.linkInbox" data-bs-toggle="modal"
                data-bs-target="#linkInbox" (click)="getInboxdd();">Link Inbox</button>
              <button class="btn btn-sm me-2"
                *ngIf="ticketsForm.get('id').value != '00000000-0000-0000-0000-000000000000'&& fp?.viewEngagement" data-bs-toggle="modal" data-bs-target="#EngementDetails"
                >View Engagement</button>
              <button class="btn btn-sm me-2"
                *ngIf="ticketsForm.get('id').value != '00000000-0000-0000-0000-000000000000'&& fp?.viewInbox" data-bs-toggle="modal"
                data-bs-target="#InboxDetails">View Inbox</button>

            </div>
          </div>  
        </div>
        <div class="card-body  widget-body pb-0 pt-2 mb-4">
          <form [formGroup]="ticketsForm">

            <div class="row mt-2 ms-2 p-10">

              <div class="col-lg-4">
                <div class="row mb-2">
                  <div class="col ">
                    <div widget class="card border-0 box-shadow">
                      <div class="card-body widget-body pt-2">

                        <div class="row mt-2" *ngIf="ticketsForm.get('id').value != '00000000-0000-0000-0000-000000000000'" >

                          <div class="col-lg-12">
                            <label>Ticket Id
                            </label>
                          </div>
                          <div class="col-lg-12">
                               <input class="form-control" [ngModelOptions]="{standalone: true}" 
                                [(ngModel)]="Tickets.uniqueTicketId" [disabled]="true" >                        

                          </div>
                        </div>

                        <div class="row mt-2">

                          <div class="col-lg-12">
                            <label>Status<sup class="super-script">&nbsp; *</sup>
                            </label>
                          </div>
                          <div class="col-lg-12">

                            <ng-select formControlName="status" [(ngModel)]="Tickets.statusLid" [searchable]="true" [clearable]="false"
                              [items]="StatusList" bindLabel="lovName" class="tdropdown" bindValue="id">
                            </ng-select>

                          </div>
                        </div>

                        <div class="row mt-2">

                          <div class="col-lg-12">
                            <label>Priority
                            </label>
                          </div>
                          <div class="col-lg-12">

                            <ng-select formControlName="priority" [(ngModel)]="Tickets.priorityLid" [searchable]="true" [clearable]="true"
                              [items]="PriorityList" bindLabel="lovName" class="tdropdown" bindValue="id">
                            </ng-select>

                          </div>
                        </div>
                        <div class="row mt-2">

                          <div class="col-lg-12">
                            <label>Type<sup class="super-script">&nbsp; *</sup>
                            </label>
                          </div>
                          <div class="col-lg-12">

                            <ng-select formControlName="tickettype" [(ngModel)]="Tickets.ticketTypeLid" [searchable]="true" [clearable]="false"
                              [items]="TypesList" bindLabel="lovName" class="tdropdown" bindValue="id">
                            </ng-select>

                          </div>
                        </div>
                        <div class="row mt-2">

                          <div class="col-lg-12">
                            <label>Assignee<sup class="super-script">&nbsp; *</sup>
                            </label>
                          </div>
                          <div class="col-lg-12">

                            <ng-select formControlName="assignee" [(ngModel)]="Tickets.employeeId" [searchable]="true" [clearable]="false"
                              [items]="EmployeeDropdown" bindLabel="Value" class="tdropdown" bindValue="Key">
                            </ng-select>

                          </div>
                        </div>
                        <div class="row mt-2">

                          <div class="col-lg-12">
                            <label>Customer
                            </label>
                          </div>
                          <div class="col-lg-12">

                            <ng-select  [(ngModel)]="Tickets.clientId" [searchable]="true" [ngModelOptions]="{standalone:true}" [clearable]="true" [disabled] = "clientTab == 'clienttab'"
                              [items]="AllClientDropDownListwithStatus" bindLabel="Value" class="tdropdown" bindValue="Key">
                            </ng-select>

                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-8">
                <div class="row mb-2">
                  <div class="col ">
                    <div widget>
                      <div>

                        <div class="row">

                          <div class="col-lg-12">
                            <label>Title<sup class="super-script">&nbsp; *</sup>
                            </label>
                          </div>
                          <div class="col-lg-12">
                            <input type="text" class="form-control" formControlName="title" [(ngModel)]="Tickets.title"
                              (ngModelChange)="ChangeTitle()">
                            <span class="help-block text-danger text-center"
                              *ngIf="!ticketsForm.get('title').valid && ticketsForm.get('title').touched ">
                              <p>Please Enter Title</p>
                            </span>
                          </div>
                        </div>


                        <div class="row mt-2">

                          <div class="col-lg-12">
                            <label>Description<sup class="super-script">&nbsp; *</sup>
                            </label>
                          </div>
                          <div class="col-lg-12">
                            <textarea rows="7" class="form-control" cols="190" formControlName="description" [(ngModel)]="Tickets.summary"></textarea>

                          </div>
                          <!-- <div class="col-lg-12 "> -->
                          <!-- app.component.html -->
                          <!--   
                              <div (click)="toggleEditor()" *ngIf="!isEditorActive">
                                <input type="text" class="form-control" formControlName="description">
                              </div>
                              <div *ngIf="isEditorActive">
                                <quill-editor    #editor placeholder="Add a Description..."  formControlName="description" 
                                  [modules]="modules"></quill-editor>
                              </div>
  
  
                            </div> -->
                        </div>
                        <!-- <div class="row mt-2">
  
                            <div class="col-lg-12">
                              <label>Attachments
                              </label>
                            </div>
                            <div class="col-lg-12">
  
                              <div class="custom-file">
                                <label class="custom-file-label" for="customFile">Choose file</label>
                                <input class="custom-file-input" id="customFile" type="file"
                                  (change)="onFileSelected($event)" multiple accept="image/*, .pdf, .docx" />
  
                                <div class="file-list" *ngIf="files.length > 0">
                                  <div class="file-item" *ngFor="let file of files">
                                    <div>{{ file.name }}</div>
                                
  
                                    <button *ngIf="(file.document != null && file.document !='' && file.document != undefined)" (click)="downloadFile(file)"><i class="fa fa-download"></i></button>
                                    <button  *ngIf="file.document == null || file.document =='' || file.document == undefined" (click)="downloadUnsavedFile(file)"><i class="fa fa-download"></i></button>
                                    <button (click)="removeFile(file)"><i class="fa fa-trash"></i></button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> -->

                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </form>



        </div>

      </div>
    </div>
  </div>



  <!-- close Alert -->
  <span id="OpenWithoutSaveTickets" data-bs-toggle="modal" data-bs-target="#WithoutSaveTicket"></span>
  <div class="modal fade modalbackgrod" id="WithoutSaveTicket" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">Close</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          You want to close without save?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn btn-sm" (click)="ticketclose=false;backtoTicketView()"
            data-bs-dismiss="modal">Yes</button>
          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
        </div>
      </div>
    </div>
  </div>




  <span id="openlinkEngagement" data-bs-toggle="modal" data-bs-target="#linkEngagement"> </span>

  <div class="modal fade" id="linkEngagement" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header">Link Engagement</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row  mt-2">
            <div class="col-12 d-flex">
              <label class="me-2 label w-25">Engagement List</label>
              <ng-select class="w-90" [(ngModel)]="LinkEngagement.engagementLogsIds" [multiple]="true"
                [items]="EngagementDropdown" bindValue='Key' bindLabel="Value">
              </ng-select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm" (click)="LinkEngagementList()">Link</button>
          <button type="button" class="btn btn-sm" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
  <span id="openlinkInbox" data-bs-toggle="modal" data-bs-target="#linkInbox"> </span>

  <div class="modal fade" id="linkInbox" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="warningModalLabel">Link Inbox</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row  mt-2">
            <div class="col-12 d-flex">
              <label class="me-2 label w-25">Inbox List</label>
              <ng-select class="w-90" [(ngModel)]="LinkInbox.engagementLogsIds" [multiple]="true"
                [items]="InboxDropdown" bindValue='Key' bindLabel="Value">
              </ng-select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm" (click)="LinkInboxList()">Link</button>
          <button type="button" class="btn btn-sm" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>

  <span id="OpenEngementDetails" data-bs-toggle="modal" data-bs-target="#EngementDetails"></span>
  <div class="modal fade modalbackgrod" id="EngementDetails" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">Linked Engagements</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <div class="row ml-2">
            <ejs-grid #engagementgrid id="engagementgrid" [dataSource]='EngagementGrid' [allowResizing]='true'
              [showColumnChooser]='false'  (dataStateChange)='dataStateChange($event)'
              >

              <e-columns>
                <!-- (rowSelected)="onRowSelected($event)"  -->
                <e-column field='' headerText="Actions" width="100" [showInColumnChooser]='false' textAlign='center'>
                  <ng-template #template let-data>
                    <button *ngIf="fp?.unlinkEngagement" class="btn btn-delete-table Ationsubbtn" data-bs-target="#Deletetickets"
                      data-bs-toggle="modal" (click)="selectedItem(data) ; unlink='engagement' "><i class="fa fa-chain-broken"></i></button>

                  </ng-template>
                </e-column>

                <e-column field="engagementId" headerText="Id" textAlign="left" type="string" width="300">
                  <ng-template #template let-data>
                    <div class="d-flex align-items-center">
                      <span class="text-truncate d-inline-block" style="width: 300px;">
                        {{ data.engagementId }}
                      </span>
                      <button class="btn btn-sm btn-light ms-2" (click)="copyToClipboard(data.engagementId)">
                        <i class="fa fa-copy"></i>
                      </button>
                    </div>
                  </ng-template>
                  </e-column>
                  <e-column field="agentName" headerText='Agent Name' textAlign='left' type='string' width="150" type='string'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value">
                      </ejs-maskedtextbox>
                    </ng-template>
                  
                  </e-column>
                  <e-column field="channelName" headerText="Channel Name" width="150" textAlign='left' [allowEditing]='false'
                    type='string'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value">
                      </ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column field="queueName" headerText="Queue Name" width="150" textAlign='left' [allowEditing]='false' type='string'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value">
                      </ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column field="direction" headerText="Direction" width="150" textAlign='left' [allowEditing]='false' type='string'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value">
                      </ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column field="dialedFrom" headerText="Dialed From" width="150" textAlign='left' [allowEditing]='false' type='string'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value">
                      </ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column field="dialedTo" headerText="Dialed To" width="150" textAlign='left' [allowEditing]='false' type='string'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value">
                      </ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column field="customerType" headerText="Customer Type" width="150" textAlign='left' [allowEditing]='false'
                    type='string'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value">
                      </ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <!-- Consultant Name -->
                  <e-column field="customerName" headerText="Customer Name" width="150" textAlign='left' [allowEditing]='false'
                    type='string'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value">
                      </ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column field="customerPhone" headerText="Customer Phone" width="150" textAlign='left' [allowEditing]='false'
                    type='string'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value">
                      </ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  
                  <e-column field="customerEmail" headerText="Customer Email" width="150" textAlign='left' [allowEditing]='false'
                    type='string'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value">
                      </ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  
                  
                  <e-column field="startTime" headerText="Start Time" width="200" textAlign='left' type="datetime"
                    [format]='formatOptions' [allowFiltering]='false'>
                  </e-column>
                  <e-column field='endTime' headerText='End Time' width="200" textAlign='left' type="datetime" [format]='formatOptions'
                    [allowFiltering]='false'>
                  </e-column>
                  <e-column field="totalDuration" headerText="Duration" width="150" textAlign='left' [allowEditing]='false' type='string'
                    [allowFiltering]='false' [allowSorting]='false'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value">
                      </ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column   field="recordingStatus" headerText="Recording" width="150" textAlign='center' 
                                    [allowEditing]='false' type='string'>
                                    <ng-template #template let-data>
                                        <button class="btn btn-sm" [style.background-color]="data.recordingStatus === 'Ready' ? 'green' : data.recordingStatus === null || data.recordingStatus === 'Uploading'  ? 'grey' : 'red' " [style.color]="'white'"
                                            [disabled]="data.recordingStatus !== 'Ready'" (click)="getmedia(data.engagementId)" *ngIf="fp?.viewEngagementRecording">
                                            {{
                                            data.recordingStatus === 'Ready' ? 'View'
                                            : (data.recordingStatus === 'Uploading'
                                            ? 'Uploading'
                                            : data.recordingStatus === null ? 'No Recording' : 'Failed')
                                            }}
                                        </button>

                                       
                                    </ng-template>
                    </e-column>
                <e-column width="50" [showInColumnChooser]='false'>
                  <ng-template #headerTemplate let-data>
                    <div class="d-none d-lg-block">
                      <span id='show' (click)='show()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                        </i></span>
                    </div>
                  </ng-template>
                </e-column>
              </e-columns>
            </ejs-grid>
          </div>
        </div>
        <div class="modal-footer">

          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>

  <span id="OpenInboxDetails" data-bs-toggle="modal" data-bs-target="#InboxDetails"></span>
  <div class="modal fade modalbackgrod" id="InboxDetails" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">Linked Inbox</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          <div class="row ml-2">
            <ejs-grid #inboxgrid id="inboxgrid" [dataSource]='InboxGrid' [allowResizing]='true'
              [allowSorting]='false' [showColumnChooser]='true' [allowFiltering]='false'
              >

              <e-columns>
                <!-- (rowSelected)="onRowSelected($event)"  -->
                <e-column field='' headerText="Actions" width="100" [showInColumnChooser]='false' textAlign='center'>
                  <ng-template #template let-data>
                    <button *ngIf="fp?.unlinkInbox" class="btn btn-delete-table Ationsubbtn" data-bs-target="#Deletetickets"
                      data-bs-toggle="modal" (click)="selectedItem(data);unlink='inbox' "><i class="fa fa-chain-broken" ></i></button>

                  </ng-template>
                </e-column>

                <e-column field="engagementId" headerText="Id" textAlign="left" type="string" width="300">
                  <ng-template #template let-data>
                    <div class="d-flex align-items-center">
                      <span class="text-truncate d-inline-block" style="width: 300px;">
                        {{ data.engagementId }}
                      </span>
                      <button class="btn btn-sm btn-light ms-2" (click)="copyToClipboard(data.engagementId)">
                        <i class="fa fa-copy"></i>
                      </button>
                    </div>
                  </ng-template>
                </e-column>
                <e-column field="channelName" headerText="Channel Name" width="150" textAlign='left' [allowEditing]='false'
                  type='string'>
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value">
                    </ejs-maskedtextbox>
                  </ng-template>
                </e-column>
              <e-column field="channelName" headerText="Channel Name" width="150" textAlign='left' [allowEditing]='false'
                type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value">
                  </ejs-maskedtextbox>
                </ng-template>
              </e-column>
              <e-column field="queueName" headerText="Queue Name" width="150" textAlign='left' [allowEditing]='false' type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value">
                  </ejs-maskedtextbox>
                </ng-template>
              </e-column>
              <e-column field="dialedFrom" headerText="Dialed From" width="150" textAlign='left' [allowEditing]='false' type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value">
                  </ejs-maskedtextbox>
                </ng-template>
              </e-column>
              <e-column field="dialedTo" headerText="Dialed To" width="150" textAlign='left' [allowEditing]='false' type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value">
                  </ejs-maskedtextbox>
                </ng-template>
              </e-column>
              <e-column field="startTime" headerText="Start Time" width="200" textAlign='left' type="datetime"
                [format]='formatOptions' [allowFiltering]='false'>
              </e-column>
              <e-column field="endTime" headerText="End Time" width="200" textAlign='left' type="datetime" [format]='formatOptions'
                [allowFiltering]='false'>
              </e-column>
              <e-column field="totalDuration" headerText="Total Duration" width="150" textAlign='left' [allowEditing]='false'
                type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value">
                  </ejs-maskedtextbox>
                </ng-template>
              </e-column>
              <e-column field="customerType" headerText="Customer Type" width="150" textAlign='left' [allowEditing]='false'
                type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value">
                  </ejs-maskedtextbox>
                </ng-template>
              </e-column>
              
              <!-- Consultant Name -->
              <e-column field="customerName" headerText="Customer Name" width="150" textAlign='left' [allowEditing]='false'
                type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value">
                  </ejs-maskedtextbox>
                </ng-template>
              </e-column>
              <e-column field="customerPhone" headerText="Customer Phone" width="150" textAlign='left' [allowEditing]='false'
                type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value">
                  </ejs-maskedtextbox>
                </ng-template>
              </e-column>
              
              <e-column field="customerEmail" headerText="Customer Email" width="150" textAlign='left' [allowEditing]='false'
                type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value">
                  </ejs-maskedtextbox>
                </ng-template>
              </e-column>
              
              <e-column field="assignedEmployeeName" headerText="Assignee" width="150" textAlign='left' [allowEditing]='false'
                type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value">
                  </ejs-maskedtextbox>
                </ng-template>
              </e-column>
              <e-column field="statusLovName" headerText="Status" width="150" textAlign='left' [allowEditing]='false' type='string'>
                <ng-template #filterTemplate let-data>
                  <ejs-maskedtextbox placeholder="Enter the value">
                  </ejs-maskedtextbox>
                </ng-template>
              </e-column>

                <e-column width="50" [showInColumnChooser]='false'>
                  <ng-template #headerTemplate let-data>
                    <div class="d-none d-lg-block">
                      <span id='show' (click)='show()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                        </i></span>
                    </div>
                  </ng-template>
                </e-column>
              </e-columns>
            </ejs-grid>
          </div>
        </div>
        <div class="modal-footer">

          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>

  <span id="OpenDeletetickets" data-bs-toggle="modal" data-bs-target="#Deletetickets"></span>
<div class="modal fade modalbackgrod" id="Deletetickets" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Unlink</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
              <span *ngIf="unlink=='engagement' ">
                Are you sure want to unlink this Engagement?
              </span>
              <span *ngIf="unlink=='inbox' ">
                Are you sure want to unlink this Inbox?
              </span>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="DeleteTickets()">Yes</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>


<span id="showChathistory" data-bs-toggle="modal" data-bs-target="#Chathistory"></span>
<div class="modal fade modalbackgrod" id="Chathistory" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                 <h2 class="modal-title  font-header-1"  >Chat Messages</h2>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body" style="max-height: 60vh; overflow-y: auto;" >                   
               <app-chat-ui [chatMessages]="messages"></app-chat-ui>
            </div>
        </div>
    </div>
</div>

<span id="showCallhistory" data-bs-toggle="modal" data-bs-target="#Callhistory"></span>
<div class="modal fade modalbackgrod" id="Callhistory" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
            <div class="modal-header">
                 <h2  class="modal-title font-header-1" >Call Recording</h2>
                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="stopAudio();" ></button>
            </div>
            <div class="modal-body" >                   
               <audio [src]="audioUrl" #audioRef controls  style="width: 100%;"></audio>
            </div>
        </div>
    </div>
</div>

       